import React, { useState, useEffect } from 'react';
import NicheSelection from './NicheSelection';
import styles from './NicheModal.module.css';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const NicheModal = ({ isOpen, onClose, user, authHeaders, viewedUser = null }) => {
    // Se estiver visualizando outro usuário (admin), usar dados do viewedUser
    const targetUser = viewedUser || user;
    const isViewingAsAdmin = Boolean(viewedUser);
    
    const [selectedNiches, setSelectedNiches] = useState(targetUser?.selectedNiches || []);
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        if (targetUser?.selectedNiches) {
            setSelectedNiches(targetUser.selectedNiches);
        }
    }, [targetUser]);

    if (!isOpen) return null;

    const handleNicheChange = (niches) => {
        setSelectedNiches(niches);
    };

    const handleSave = async () => {
        setIsSaving(true);
        setError('');
        setSuccess('');
        try {
            // Se for admin visualizando outro usuário, usar rota de admin
            const endpoint = isViewingAsAdmin 
                ? `${API_BASE}/api/admin/users/${targetUser._id}/niches`
                : `${API_BASE}/api/user/niches`;
            
            await axios.put(endpoint, { niches: selectedNiches }, { headers: authHeaders });
            setSuccess('Suas preferências foram salvas!');
            setIsSaving(false); // Para de mostrar "Salvando..."
            // Aguarda 2 segundos para o usuário ver a mensagem no botão, depois fecha
            setTimeout(() => {
                setSuccess('');
                onClose(true); // passa true para indicar que houve mudança
            }, 2000);
        } catch (err) {
            setError('Ocorreu um erro ao salvar. Tente novamente.');
            console.error("Error saving niches:", err);
            setIsSaving(false);
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button className={styles.closeButton} onClick={onClose}>&times;</button>
                <h2>Gerenciar Nichos</h2>
                <p>Selecione as categorias de produtos que você deseja receber em seu grupo.</p>
                
                <div className={styles.platformTabs}>
                    <button className={`${styles.tab} ${styles.active}`}>
                        <img src="/shopee.svg" alt="Shopee" />
                        Shopee
                    </button>
                    <button className={`${styles.tab} ${styles.disabled}`}>
                        <img src="/amazon.svg" alt="Amazon" />
                        Amazon
                        <span className={styles.soonBadge}>Em Breve</span>
                    </button>
                </div>

                <NicheSelection
                    selectedNiches={selectedNiches}
                    onNicheChange={handleNicheChange}
                />

                <div className={styles.modalActions}>
                    {error && <p className={styles.error}>{error}</p>}
                    <button 
                        onClick={handleSave} 
                        disabled={isSaving || success}
                        className={success ? styles.successButton : ''}
                    >
                        {success ? '✓ Suas preferências foram salvas!' : isSaving ? 'Salvando...' : 'Salvar Preferências'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NicheModal;
